import React, { useContext } from 'react'
import LeftProfile from '../components/others/LeftProfile'
import { Helmet } from 'react-helmet'
import translations from '../data/langData';
import { LanguageContext } from '../context/LanguageContext';

const Contact = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  return (
    <>
      <Helmet>
      <title>{t.contact}</title>
    </Helmet>
     <section className="content-box-area mt-4">
  <div className="container">
    <div className="row g-4">
      <LeftProfile/>
      <div className="col-xl-8">
        <div className="card content-box-card">
          <div className="card-body portfolio-card contact-card">
            <div className="top-info">
              <div className="text">
                <h1 className="main-title" dangerouslySetInnerHTML={{__html:t.contactMe}}/>
                <p>{t.feedback}</p>
              </div>
            </div>
            <div className="contact-area">
              <div className="leave-comments-area">
                <div className="comments-box">
                  <form id="contact-form"  method="POST">
                    <div className="row gx-3">
                      <div className="col-md-6">
                        <div className="mb-4">
                          <label className="form-label">{t.name}</label>
                          <input name="name" required type="text" className="form-control shadow-none" placeholder="Enter your name" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-4">
                          <label className="form-label">{t.email}</label>
                          <input name="email" required type="email" className="form-control shadow-none" placeholder="Enter your email" />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="mb-4">
                          <label className="form-label">{t.subject}</label>
                          <textarea name="message" className="form-control shadow-none" rows={4} placeholder="Type details about your inquiry" defaultValue={""} />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <button className="submit-btn" type="submit">
                          {t.send}
                          <svg className="icon" width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.5 11.6665V6.6665H12.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M17.5 6.6665L10 14.1665L2.5 6.6665" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </form>
                  <p className="ajax-response mb-0" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

    </>
  )
}

export default Contact
